import React, { useState, useRef, useEffect } from "react";
import { useProfile } from "../contexts/ProfileContext";
import { supabase } from "../supabaseClient";
import ManageOwners from "./ManageOwners";
import { useNavigate } from "react-router-dom";

function ProfileAvatar({
  profile,
  showManageOwners,
  setShowManageOwners,
  userId,
}) {
  const { setSelectedProfile } = useProfile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Handle clicking outside the menu to close it
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSwitchProfile = () => {
    setSelectedProfile(null);
    setIsMenuOpen(false);
  };

  const handleSignOut = async () => {
    // Sign out from Supabase
    await supabase.auth.signOut();
    setIsMenuOpen(false);
  };

  const handleManageOwners = () => {
    setShowManageOwners(true);
    setIsMenuOpen(false);
  };

  return (
    <>
      <div
        className="fixed top-4 right-4 flex items-center gap-2 z-40"
        ref={menuRef}
      >
        <span className="text-sm font-medium">{profile.name}</span>
        <div className="dropdown dropdown-end">
          <div
            tabIndex={0}
            role="button"
            className="w-12 h-12 rounded-full overflow-hidden hover:opacity-80 transition-opacity border-2 border-primary"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <img
              src={profile.avatar_url}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </div>
          {isMenuOpen && (
            <ul
              tabIndex={0}
              className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52"
            >
              <li>
                <button
                  className="btn btn-ghost justify-start w-full"
                  onClick={handleSwitchProfile}
                >
                  Switch Profile
                </button>
              </li>
              <li>
                <button
                  className="btn btn-ghost justify-start w-full"
                  onClick={handleManageOwners}
                >
                  Manage Owners
                </button>
              </li>
              {userId === "5e43c70c-64ce-4332-b229-0a9574429378" && (
                <li>
                  <button
                    className="btn btn-ghost justify-start w-full text-error"
                    onClick={() => {
                      setIsMenuOpen(false);
                      navigate("/admin");
                    }}
                  >
                    Admin Console
                  </button>
                </li>
              )}
              <li>
                <button
                  className="btn btn-ghost justify-start w-full"
                  onClick={handleSignOut}
                >
                  Sign Out
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
      {showManageOwners && (
        <ManageOwners onClose={() => setShowManageOwners(false)} />
      )}
    </>
  );
}

export default ProfileAvatar;
